import React, { ReactElement } from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import { InputTextarea, InputTextareaProps } from "primereact/inputtextarea";

interface InputTxtAreaProps extends InputTextareaProps {
  label: string;
  name: string;
  value: any;
  warn: string;
  isRequired?: boolean;
  extendedlabel?: string | ReactElement;
  saveprompt?: string;
}

export default function InputTextareaComponent(props: InputTxtAreaProps) {
  const { name, label, warn, extendedlabel, isRequired, ...rest } = props;
  const { setFieldTouched, setFieldValue, getFieldMeta } = useFormikContext();
  const fieldMeta = getFieldMeta(name);

  return (
    <div className="flex flex-column w-full py-2 txt-area-height" id={name.split(".").pop()}>
      {label && !props?.hidden && (
        <label htmlFor={name} className={isRequired ? "isRequired" : ""} id={name.split(".").pop()}>
          {" "}
          {label}
        </label>
      )}
      {extendedlabel && (
        <div className="helpertext">
          <i>{extendedlabel}</i>
        </div>
      )}
      <div>
        {" "}
        <Field
          alt={name}
          name={name}
          rows={5}
          col={30}
          autoResize
          {...rest}
          value={rest.value ?? ""}
          as={InputTextarea}
          onChange={(e: any) => {
            setFieldTouched(name, true, true);
            setFieldValue(name, e.target.value);
          }}
        />
        {rest.value != undefined && <div className="printable-textarea-content">{rest.value}</div>}
      </div>
      {warn && <div className=" text-left fieldadv">{warn}</div>}
      <ErrorMessage name={name ?? ""} render={(msg) => <div className="error">{msg}</div>} />
      {fieldMeta.touched && rest.saveprompt && !rest.disabled && rest.value && <div className="save-prompt-text">{rest.saveprompt}</div>}
    </div>
  );
}
